<template>
    <v-card class="elevation-12" id="login">
        <v-toolbar dark color="primary">
            <v-toolbar-title>{{trans('auth-pages.login.title')}}</v-toolbar-title>

            <v-btn
                    color="cyan"
                    fab
                    dark

                    :title="trans('auth-pages.actions.register')"
                    absolute
                    bottom
                    right

                    v-if="allowRegistration"
                    @click="register"
            ><v-icon>person_add</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>

            <v-alert
                    v-if="error"
                    type="error"
                    >{{error}}
            </v-alert>
            <v-form
                ref="form"
                @submit.prevent
                v-model="validForm"
                >
                <v-text-field
                    v-if="emailLogin"
                    prepend-icon="email"
                    name="email"
                    type="email"
                    :label="trans('auth-pages.login.labels.email')"
                    :rules="emailRules"
                    :required="true"

                    :loading="loading"
                    autocomplete="user-email"
                    :error-messages="fieldErrors.email"
                    @input="resetError('email')"
                    v-model="email"
                    validate-on-blur

                    ></v-text-field>
                <v-text-field
                    v-else
                    prepend-icon="person"

                    autocomplete="user-name"
                    name="login"
                    :label="trans('auth-pages.login.labels.username')"
                    type="text"
                    v-model="username"
                    :required="true"
                    validate-on-blur

                    :error-messages="fieldErrors.username"
                    @input="resetError('username')"
                ></v-text-field>
                <v-text-field
                    prepend-icon="lock"
                    name="password"
                    :label="trans('auth-pages.login.labels.password')"
                    type="password"
                    v-model="password"
                    :required="true"
                    autocomplete="user-password"
                    :error-messages="fieldErrors.password"
                    @input="resetError('password')"

                    ></v-text-field>
                <v-checkbox
                    :label="trans('auth-pages.login.remember-me')"
                    v-model="remember"
                    ></v-checkbox>
            </v-form>
        </v-card-text>
        <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn
                    :disabled="!validForm"
                    color="primary"
                    @click="submit"
                    :loading="loading"
                    ><v-icon left>send</v-icon>{{trans('auth-pages.login.submit')}}</v-btn>


            <v-btn
                    text
                    small

                    @click="forgot"
                    color="secondary"
                    >{{trans('auth-pages.login.forgot')}}</v-btn>

            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        name: "login",
        props: {
            allowRegistration:{type:Boolean,default:false,},
            emailLogin:{type:Boolean,default:true,},
            action:{type:String,default:'/login'},
        },
        data() {
            return {
                email:'',
                username:'',
                password:'',
                remember:false,

                emailRules:[v => {return /^\w+([.+\-]?[\w\d]+)*@\w+([.-]?\w+)(\.\w{2,})+$/.test(v)||'invalid email'}],

                validForm:false,
                loading:false,

                error:null,

                fieldErrors:{},
            }
        },
        mounted() {
        },
        computed: {
        },
        methods: {
            forgot(){this.$emit('password-reset');},
            register(){this.$emit('register');},
            submit(){
                if(this.$refs.form.validate()){
                    this.loading = true;
                    let data ={
                        password:this.password ,
                        remember:this.remember
                    };
                    if(this.emailLogin)
                        data.email=this.email;
                    else
                        data.username=this.username;

                    axios.post(this.action,data)
                        .then(r=>{
                            let redirect = (r.data && r.data.redirect)?r.data.redirect:r.request.responseURL;

                            this.$emit('logged',{response:r,redirect})
                        })
                        .catch(e=>{
                            console.error(e);
                            if(e.response){
                                if(e.response.data){
                                    console.log({e});
                                    if(e.response.status===422){
                                        this.fieldErrors = e.response.data.errors;
                                    }

                                    this.error = e.response.data.message;
                                }
                                else{
                                    this.error=e.response;
                                }
                            }else{
                                this.error=e;
                            }
                        })
                        .finally(()=>{
                            this.loading = false;
                        });
                }
            },
            resetError(field){
                //this.fieldErrors[field]=[];
                this.fieldErrors=[];//Always reset all fields errors
                this.error=null
            },
        },

        components: {},
        filters: {}
    }
</script>
